export default __webpack_public_path__ + "static/media/ad-1.58299c95.png";